// 9fbef606107a605d69c0edbcd8029e5d
const LOYALTY_PLACE_REWARDS_CONSTANTS = {
  SET_LOYALTY_TIER_BENEFITS: 'SET_LOYALTY_TIER_BENEFITS',
  REDEEM_LOYALTY_POINTS: 'REDEEM_LOYALTY_POINTS',
  CLEAR_API_ERRORS: 'CLEAR_API_ERRORS',
  SET_POINTS_REDEMPTION_IN_PROGRESS: 'SET_POINTS_REDEMPTION_IN_PROGRESS',
  REDEEM_API_ERROR: 'REDEEM_API_ERROR',
  POINTS_TO_REDEEM: 'POINTS_TO_REDEEM',
  GET_TIER_BENEFITS: 'GET_TIER_BENEFITS',
  BENEFIT_REDEEMED: 'Redeemed',
  BENEFIT_EXPIRED: 'Expired',
  BENEFIT_EXPIRING_SOON: 'Expiring Soon',
  FETCH_LOYALTY_BENEFIT_JSON_REQUEST: 'FETCH_LOYALTY_BENEFIT_JSON_REQUEST',
  FETCH_LOYALTY_BENEFIT_JSON_SUCCESS: 'FETCH_LOYALTY_BENEFIT_JSON_SUCCESS',
  FETCH_LOYALTY_BENEFIT_JSON_FAILURE: 'FETCH_LOYALTY_BENEFIT_JSON_FAILURE',
  GET_MODULE_X_CONTENT: 'GET_MODULE_X_CONTENT',
  SET_MODULE_X_CONTENT: 'SET_MODULE_X_CONTENT',
  FETCH_EA_PRODUCTS: 'FETCH_EA_PRODUCTS',
  SET_EA_PRODUCTS: 'SET_EA_PRODUCTS',
};

export default LOYALTY_PLACE_REWARDS_CONSTANTS;
